import { PAGE_ANALYTICS_INFO, PAGE_TYPE } from '../page-types'
import type { RouteLocationNormalized } from 'vue-router'

/* ------- MICROFRONT - PDP ------- */

export const pdpRoutes = [
  {
    path: '/p/:productSlug',
    name: 'product',
    component: () => import('@b2ag/micro-front-pdp/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'pdp',
      viewName: 'default',
      productSlug: route.params.productSlug,
    }),
    meta: {
      analyticsPageType: PAGE_TYPE.PRODUCT_PAGE,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.PRODUCT_PAGE,
      private: false,
      showSearchBar: true,
      showSelectedCustomer: true,
      disabledLayoutAlternate: true,
    },
  },
]
